module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "q_avatar",
    on: {
      "mouseover": function($event) {
        _vm.showImageControl(true)
      },
      "mouseleave": function($event) {
        _vm.showImageControl(false)
      }
    }
  }, [_c('img', {
    ref: "accountImage",
    staticClass: "img img-responsive",
    attrs: {
      "src": _vm.formData.imageUrl == '' ? (_vm.formData.picture ? _vm.formData.picture : '/static/img/placeholder.png') : '/image/Account/' + _vm.formData.imageUrl + '?' + Date.now(),
      "border": "1"
    }
  }), _vm._v(" "), _c('div', {
    ref: "imageControl",
    staticClass: "q_form_image_controls"
  }, [_c('span', {
    staticClass: "icon ion-pencil pull-left q_select_file_button",
    attrs: {
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.$refs.filePicture.click()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon ion-ios-trash-o pull-right q_clear_file_button",
    attrs: {
      "title": "Clear"
    },
    on: {
      "click": function($event) {
        _vm.clearPicture()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "q_hidden_input_file "
  }, [_c('input', {
    ref: "filePicture",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.pictureChange
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.emailAddress),
      expression: "formData.emailAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputEmail",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.formData.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "emailAddress", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("General Info")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_AUTH_PROFILE
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onTabAuthProfile()
      }
    }
  }, [_vm._v("Authorization Profile")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.tabActive == _vm.TAB_ROLE
    }
  }, [_c('a', {
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.onTabRole()
      }
    }
  }, [_vm._v("Role")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_GENERAL
    },
    attrs: {
      "id": "tab_1"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputName",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputHP"
    }
  }, [_vm._v("HP No.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.handPhoneNo),
      expression: "formData.handPhoneNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputHP",
      "placeholder": "",
      "disabled": _vm.viewMode == _vm.MODE_VIEW
    },
    domProps: {
      "value": (_vm.formData.handPhoneNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "handPhoneNo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputLastLogin"
    }
  }, [_vm._v("Last Login")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lastLogin),
      expression: "formData.lastLogin"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLastLogin",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formData.lastLogin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lastLogin", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "inputHP"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPassword",
      "placeholder": "",
      "disabled": _vm.viewMode != _vm.MODE_CREATE
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "password", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_ROLE
    },
    attrs: {
      "id": "tab_2"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-3 pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authProfileName),
      expression: "authProfileName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.viewMode == _vm.MODE_VIEW,
      "id": "inputName"
    },
    domProps: {
      "value": (_vm.authProfileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authProfileName = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.listAuthProfile), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "width": "20px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSeqAuthProfile + i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.authObjectName))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.authFieldName))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.value))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.authObjectId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.authFieldId))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.authProfileId))])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.tabActive == _vm.TAB_ROLE
    },
    attrs: {
      "id": "tab_3"
    }
  }, [_c('div', {
    staticClass: "box no-border"
  }, [_c('div', {
    staticClass: "box-body no-padding"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roleIdSelected),
      expression: "roleIdSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.viewMode === _vm.MODE_VIEW
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.roleIdSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listRole), function(row, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": row.id
      }
    }, [_vm._v("\n                                " + _vm._s(row.name) + "\n                              ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 no-padding"
  }, [(_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "height": "32px",
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.onAddRole()
      }
    }
  }, [_vm._v("Add")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [(_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "height": "32px",
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.onGenerateAuthProfile()
      }
    }
  }, [_vm._v("Generate Auth Profile")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.listUserRole), function(row, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "width": "20px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.startSeqUserRole + i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "width": "40px",
        "text-align": "center"
      }
    }, [(_vm.viewMode != _vm.MODE_VIEW) ? _c('a', {
      staticStyle: {
        "padding-right": "5px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.onDeleteRole(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon ion-ios-trash",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": "Delete"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "hidden": ""
      }
    }, [_vm._v(_vm._s(row.id))])])
  }))])])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.id),
      expression: "formData.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "hidden",
      "id": "inputId"
    },
    domProps: {
      "value": (_vm.formData.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "box-tools"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onBack()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        _vm.onCancel()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (_vm.viewMode != _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onSave()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    on: {
      "click": function($event) {
        _vm.onEdit(_vm.formData)
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.viewMode == _vm.MODE_VIEW) ? _c('button', {
    staticClass: "btn btn-info pull-right",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.onCreate()
      }
    }
  }, [_vm._v("Create")]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Auth Object")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Auth Field")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Value")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20px",
      "text-align": "right"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px",
      "text-align": "center"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Role")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78aaf1b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/UserForm.vue
// module id = 758
// module chunks = 1